{
  "name": "@relayplane/sdk",
  "version": "1.1.9",
  "description": "RelayPlane SDK - Local-first AI workflow engine for building multi-step AI workflows",
  "main": "./dist/index.js",
  "module": "./dist/index.mjs",
  "types": "./dist/index.d.ts",
  "exports": {
    ".": {
      "types": "./dist/index.d.ts",
      "import": "./dist/index.mjs",
      "require": "./dist/index.js"
    }
  },
  "scripts": {
    "build": "tsup && rm -f tsconfig.tsbuildinfo && tsc --emitDeclarationOnly --declaration",
    "dev": "tsup --watch",
    "test": "vitest run",
    "test:watch": "vitest",
    "test:coverage": "vitest run --coverage",
    "lint": "eslint src --ext .ts",
    "type-check": "tsc --noEmit",
    "clean": "rm -rf dist"
  },
  "keywords": [
    "sdk",
    "workflow",
    "ai",
    "local-first",
    "llm",
    "openai",
    "anthropic",
    "claude",
    "gpt",
    "relayplane"
  ],
  "author": "RelayPlane",
  "license": "MIT",
  "homepage": "https://relayplane.com",
  "bugs": "https://github.com/RelayPlane/sdk/issues",
  "publishConfig": {
    "access": "public",
    "registry": "https://registry.npmjs.org/"
  },
  "files": [
    "dist",
    "README.md",
    "LICENSE"
  ],
  "peerDependencies": {
    "@anthropic-ai/sdk": ">=0.32.0",
    "@google/generative-ai": ">=0.24.0",
    "openai": ">=4.20.0",
    "zod": ">=3.22.0"
  },
  "peerDependenciesMeta": {
    "@anthropic-ai/sdk": {
      "optional": true
    },
    "@google/generative-ai": {
      "optional": true
    },
    "openai": {
      "optional": true
    }
  },
  "dependencies": {
    "@relayplane/adapters": "^0.1.5"
  },
  "devDependencies": {
    "@relayplane/engine": "workspace:*",
    "@relayplane/mcp": "workspace:*",
    "@relayplane/telemetry": "workspace:*",
    "@types/node": "^20.10.0",
    "@vitest/coverage-v8": "^1.1.0",
    "tsup": "^8.5.1",
    "typescript": "^5.3.3",
    "vitest": "^1.1.0"
  }
}
